import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import MarkupActions from '../Redux/MarkupRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getMarkup (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getMarkup, token, action.filter)
      if (!res.ok) {
        yield put(MarkupActions.markupFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const data_with_page = {
            data: res.data.data,
            page,
            total
          }
          yield put(MarkupActions.markupSuccess(data_with_page))
        } else {
          yield put(MarkupActions.markupFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(MarkupActions.markupFailure())
  }
}

export function * createMarkup (api, action) {
  yield baseFetchToken(api.createMarkup,
    action.data,
    getToken,
    MarkupActions.markupCreateSuccess,
    MarkupActions.markupCreateFailure)
}

export function * updateMarkup (api, action) {
  yield baseFetchToken(api.updateMarkup,
    action.data,
    getToken,
    MarkupActions.markupUpdateSuccess,
    MarkupActions.markupUpdateFailure)
}

export function * deleteMarkup (api, action) {
  yield baseFetchToken(api.deleteMarkup,
    action.data,
    getToken,
    MarkupActions.markupDeleteSuccess,
    MarkupActions.markupDeleteFailure)
}

export function * markupItemGet (api, action) {
  yield baseFetchToken(
    api.markupItemGet,
    action.data,
    getToken,
    MarkupActions.markupItemGetSuccess,
    MarkupActions.markupItemGetFailure
  )
}

export function * markupItemCreate (api, action) {
  yield baseFetchToken(
    api.markupItemCreate,
    action.data,
    getToken,
    MarkupActions.markupItemCreateSuccess,
    MarkupActions.markupItemCreateFailure
  )
}

export function * markupItemUpdate (api, action) {
  yield baseFetchToken(
    api.markupItemUpdate,
    action.data,
    getToken,
    MarkupActions.markupItemUpdateSuccess,
    MarkupActions.markupItemUpdateFailure
  )
}

export function * markupItemDelete (api, action) {
  yield baseFetchToken(
    api.markupItemDelete,
    action.data,
    getToken,
    MarkupActions.markupItemDeleteSuccess,
    MarkupActions.markupItemDeleteFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/MarkupSagas.js